// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"sJ-z","smallCardRow":"tJ-z","largeCardRow":"uJ-z","productSearchRow":"vJ-z","curatedRow":"wJ-z"};